module.exports = __webpack_public_path__ + "img/part-all.4a11011.png";